
import * as bootstrap from "bootstrap";

export default class Tooltips {
  constructor() {
    console.log("%cTooltips", "color: yellow");
    this.init();
  }

  init() {
  
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
   [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));

  }
}